import { Button } from '@/components/ui/button'
import { GlobeLockIcon, LayoutListIcon, UserPlusIcon } from 'lucide-react'
import Image from 'next/image'
import { HomeContentBlock, HomeFeatureItem, HomeSection, HomeTitle } from './base'

const features = [
  {
    icon: <UserPlusIcon className='w-6 h-6 stroke-1' />,
    text: 'Manage teams, assign roles, approve access requests',
  },
  {
    icon: <LayoutListIcon className='w-6 h-6 stroke-1' />,
    text: 'Dynamic Post Creation',
  },
  {
    icon: <GlobeLockIcon className='w-6 h-6 stroke-1' />,
    text: 'Role-based Access Control',
  },
]

const UseCaseCTA = () => {
  return (
    <HomeSection padding='base' layout='grid' className='lg:grid-cols-2'>
      <div className='order-2 lg:order-1 flex justify-center lg:justify-start'>
        <Image
          src='/images/home/ctausecase_img.webp'
          alt='Use Case'
          width={1000}
          height={1000}
          loading='lazy'
          className='w-full h-auto max-w-md lg:max-w-none'
        />
      </div>

      <div className='order-1 lg:order-2'>
        <HomeContentBlock spacing='xl'>
          <div className='space-y-6'>
            <HomeTitle>Try the platform sports media pros have been waiting for</HomeTitle>

            <div className='space-y-4'>
              {features.map((feature) => (
                <HomeFeatureItem key={feature.text} icon={feature.icon} text={feature.text} />
              ))}
            </div>
          </div>

          <div className='w-fit'>
            <Button
              variant='outline'
              className='border-neutral-600 text-neutral-800'
              onClick={() => window.open('https://calendly.com/rtsc-demo', '_blank')}
            >
              Request a Demo
            </Button>
          </div>
        </HomeContentBlock>
      </div>
    </HomeSection>
  )
}

export default UseCaseCTA
